import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { Fragment, useContext, useState } from "react";
import propTypes from "prop-types";
import TextInputField from "../../components/editable/EditableField/fields/TextInputField";
import { api, ICreateCustomerWithDatabase } from "../../logic/api";
import NumberInputField from "../../components/editable/EditableField/fields/NumberInputField";
import { SessionContext } from "../../utility/useSession";
import { ProgressDialog } from "../../components/notifications/progressDialog/progressDialog";
import ErrorDialog from "../../components/notifications/errorDialog/ErrorDialog";
import { useTranslation } from "react-i18next";

const CreateCustomerDialog: React.FunctionComponent<{
  show: boolean;
  onClose: (updated: boolean) => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  const [customer, setCustomer] = useState<ICreateCustomerWithDatabase>({
    airportCode: "",
    clientCode: "",
    customerName: "",
    host: "localhost",
    port: 3306,
  });

  const createCustomer = api.hooks.admin.createCustomerWithDatabase();

  let disabled = false;

  if (customer.customerName.length == 0) {
    disabled = true;
  } else if (customer.airportCode.length == 0) {
    disabled = true;
  } else if (customer.host.length == 0) {
    disabled = true;
  } else if (customer.port <= 0 || customer.port >= 65553) {
    disabled = true;
  }

  const create = () => {
    createCustomer.send(session.current.context, customer, (result) => {
      if (result != null) {
        props.onClose(true);
      }
    });
  };

  return (
    <Fragment>
      <Dialog open={props.show}>
        <DialogTitle>{t("admin.createCustomer")}</DialogTitle>
        <DialogContent>
          <ErrorDialog err={createCustomer.err}></ErrorDialog>
          <ProgressDialog status={createCustomer.status}></ProgressDialog>

          <div style={{ marginBottom: 20 }}>
            <TextInputField
              label={t("input.labels.customerName")}
              value={customer.customerName}
              onChange={(value) => {
                setCustomer({ ...customer, customerName: value });
              }}
            ></TextInputField>
          </div>
          <div style={{ marginBottom: 20 }}>
            <TextInputField
              label={t("admin.clientCode")}
              value={customer.clientCode}
              onChange={(value) => {
                setCustomer({ ...customer, clientCode: value });
              }}
            ></TextInputField>
          </div>
          <div style={{ marginBottom: 20 }}>
            <TextInputField
              label={t("admin.carparkIATACode")}
              value={customer.airportCode}
              onChange={(value) => {
                setCustomer({ ...customer, airportCode: value });
              }}
            ></TextInputField>
          </div>
          <div style={{ marginBottom: 20 }}>
            <TextInputField
              label={t("admin.host")}
              value={customer.host}
              onChange={(value) => {
                setCustomer({ ...customer, host: value });
              }}
            ></TextInputField>
          </div>

          <div style={{ marginBottom: 20 }}>
            <NumberInputField
              label={t("admin.port")}
              value={customer.port}
              onChange={(value) => {
                setCustomer({ ...customer, port: value });
              }}
            ></NumberInputField>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props.onClose(false);
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            disabled={disabled}
            onClick={() => {
              create();
            }}
          >
            <b>{t("general.create")}</b>
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

CreateCustomerDialog.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};
export default CreateCustomerDialog;
